import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import { connectRouter } from "connected-react-router";
import storage from "redux-persist/es/storage";
import store, { history } from "../boot/configureStore";

import DashboardReducer from "../containers/DefaultLayout/reducer";
import UserReducer from "../containers/UsersContainer/reducer";
import SignupReducer from "../containers/SignupContainer/reducer";
import SupportCenterReducer from "../containers/SupportCenterContainer/reducer";
import PartnerRequestReducer from "../containers/PartnerRequestContainer/reducer";
import AddOutboxRequestReducer from "../containers/AddOutboxRequestContainer/reducer";
import vehicleReducer from "../containers/MyVehiclesContainer/reducer";
import AddNewDriverReducer from "../containers/AddNewDriverContainer/reducer";
import DriverReducer from "../containers/DriversContainer/reducer";
import MyPlanReducer from "../containers/MyPlansContainer/reducer";
import MySubscriptionReducer from "../containers/MySubscriptionContainer/reducer";
import tripDesignReducer from "../containers/TripDesignContainer/reducer";
import loadReducer from "../containers/LoadBoardContainer/reducer";
import MyTeamsReducer from "../containers/MyTeamsContainer/reducer";
import MyDriverReducer from "../containers/MyDriversContainer/reducer";
import TripDesignCrudReducer from "../containers/TripDesignCrudContainer/reducer";
import shipperReducer from "../containers/ShipperContainer/reducer";
import loadMetricsReducer from "../containers/LoadMetricsContainer/reducer";
import RateCardReducer from "../containers/RateCardContainer/reducer";
import tripEventsReducer from "../containers/TripEventsContainer/reducer";
import ProfileupdateReducer from "../containers/ProfileUpdateContainer/reducer";
import completedOrderReducer from "../containers/CompletedOrderContainer/reducer";
import shipperprofReducer from "../containers/MyProfileContainer/reducer";
import editshipperprofReducer from "../containers/EditProfileContainer/reducer";
import expenseReducer from "../containers/ExpenseContainer/reducer";
import invoiceReducer from "../containers/InvoiceContainer/reducer";
import runnerinvoiceReducer from "../containers/RunnerInvoiceContainer/reducer";
import paymentsReducer from "../containers/PaymentContainer/reducer";
import operationLocReducer from "../containers/RunnerOperatingLocContainer/reducer";
import RunnerSubscriptionsReducer from "../containers/RunnerSubsptnContainer/reducer";
import notificationReducer from "../containers/NotificationContainer/reducer";
import forgotPasswordReducer from "../containers/ForgottPasswordContainer/reducer";
import WarehouseReducer from "../containers/WarehouseManagementContainer/reducer";
import WarehousePlanReducer from "../containers/WarehousePlanContainer/reducer";
import OthersWarehouseSubsptnReducer from "../containers/UserSbsrptnWarehouseContainer/reducer";
import MySubscriptionsWarehouseReducer from "../containers/MySubscriptionsWarehouseContainer/reducer";
import WarehouseSubscriptionsReducer from "../containers/WarehouseSubsrptnsContainer/reducer";
import UserPlanSbsrptnWarehseReducer from "../containers/UserPlanSbsrptnWarehseContainer/reducer";
import WarehsProviderSbsrptnReducer from "../containers/WarehsProviderSbsrptnContainer/reducer";
import WarehsPerformanceReducer from '../containers/WarehousePerformanceContainer/reducer';
import runnerPaymentsReducer from '../containers/RunnerPaymentsContainer/reducer';
import invoiecConfigReducer from '../containers/InvoiceConfigContainer/reducer';

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    DashboardReducer,
    UserReducer,
    SignupReducer,
    SupportCenterReducer,
    PartnerRequestReducer,
    AddOutboxRequestReducer,
    vehicleReducer,
    AddNewDriverReducer,
    DriverReducer,
    MyPlanReducer,
    MySubscriptionReducer,
    tripDesignReducer,
    loadReducer,
    MyTeamsReducer,
    TripDesignCrudReducer,
    MyDriverReducer,
    shipperReducer,
    loadMetricsReducer,
    RateCardReducer,
    tripEventsReducer,
    ProfileupdateReducer,
    completedOrderReducer,
    shipperprofReducer,
    editshipperprofReducer,
    expenseReducer,
    invoiceReducer,
    paymentsReducer,
    operationLocReducer,
    RunnerSubscriptionsReducer,
    notificationReducer,
    forgotPasswordReducer,
    WarehouseReducer,
    WarehousePlanReducer,
    OthersWarehouseSubsptnReducer,
    MySubscriptionsWarehouseReducer,
    WarehouseSubscriptionsReducer,
    UserPlanSbsrptnWarehseReducer,
    runnerinvoiceReducer,
    WarehsProviderSbsrptnReducer,
    WarehsPerformanceReducer,
    runnerPaymentsReducer,
    invoiecConfigReducer
  });

export default createRootReducer;
